<template>
    <div id="app" @contextmenu.prevent="">
        <!-- <keep-alive> -->
        <router-view></router-view>
        <!-- </keep-alive> -->
    </div>
</template>
<script>
  // 引入全局样式
  import './css/global.less';
  import gql from 'graphql-tag';
  import raceJs from './race.js';
  export default {
    
    data() {
      return {
        idForRefresh: raceJs.version,
      };
    },
    
    methods: {
      async versionForRefresh() {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              getVersionControl {
                id
                version_num
                version_type
              }
            }`,
            fetchPolicy: "no-cache",
          });
          let data;
          for (const item of res.data.getVersionControl) {
            if (item.version_type === 'pc') {
              data = item;
            }
          }
          if (data) {
            // if (data.version_num !== this.idForRefresh) {
            //   window.location.reload();
            //}
            console.log("front version:",this.idForRefresh);
          }
        } catch (error) {
          console.log(error);
        }
      },
    },
    
    created() {
      // 判断版本 刷新页面
      this.versionForRefresh();
      // 长连接
      window.lastHeartBeat = new Date();
      setInterval(() => {
        const now = new Date();
        if (now - window.lastHeartBeat >= 1100) {
          if (!window.eventSrc || window.eventSrc.readyState !== EventSource.CONNECTING) {
            this.$root.$emit('connect2server');
          }
        }
      }, 500);
    },
    
  }
</script>

<style lang="less">
    @import "./assets/style/style.less";
    
    html, body {
        width: 100%;
        height: 100%;
        font-size: 16/136.533rem;
        font-family: Helvetica;
    }
    
    body {
        margin: 0;
    }
    
    /*body::-webkit-scrollbar{*/
    /*display: none;*/
    /*}*/
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        width: 100%;
        height: 100%;
    }
    
    #nav {
        padding: 30px;
    }
    
    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }
    
    #nav a.router-link-exact-active {
        color: #42b983;
    }
    
    /* http://meyerweb.com/eric/tools/css/reset/
       v2.0 | 20110126
       License: none (public domain)
    */
    
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    
    body {
        line-height: 1;
    }
    
    ol, ul {
        list-style: none;
    }
    
    blockquote, q {
        quotes: none;
    }
    
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    
    // element性别按钮样式
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: @sColor;
        border-color: rgba(0, 0, 0, 0);
        box-shadow: -1px 0 0 0 rgba(0, 0, 0, 0);
    }
    
    .el-radio-button__inner:hover {
        color: @sColor;
    }
    
    // element按钮样式修改
    .el-button--primary.is-disabled {
        border-color: rgba(0, 0, 0, 0);
        background-color: rgba(77, 162, 190, 0.44);
    }
    
    .el-button--primary.is-disabled:hover {
        background-color: rgba(77, 162, 190, 0.44);
        border-color: rgba(0, 0, 0, 0);
    }
    
    .el-button--primary {
        background-color: @sColor;
        border-color: rgba(0, 0, 0, 0);
    }
    
    .el-button--primary:hover {
        background-color: @sColor;
        border-color: rgba(0, 0, 0, 0);
    }
    
    .el-button--primary:focus {
        background-color: @sColor;
        border-color: rgba(0, 0, 0, 0);
    }
    
    .el-autocomplete-suggestion li {
        padding: 0 8px;
    }
    
    .el-scrollbar__wrap {
        overflow: auto !important;
    }
    
    // 查看大图dialog样式
    .showBigImage_dialog {
        position: relative;
        min-height: 950px;
    }
    
    .showBigImage_dialog_1 .el-dialog__body {
        padding-top: 10px;
    }
    
    // 远程获取左侧tree样式修改
    .my-el-tree .el-tree-node__expand-icon {
        color: #666;
        font-size: 16px;
    }
    
    .my-el-tree .is-leaf.el-tree-node__expand-icon {
        color: rgba(255, 255, 255, 0);
    }
    
    .my-el-tree .el-tree-node__label {
        color: #000;
    }
    
    .my-el-tree.el-tree--highlight-current .is-current > .el-tree-node__content {
        background-color: rgba(77, 162, 190, .8) !important;
    }
    
    // 患者列表页面 修改患者信息弹窗的选择民族下拉框样式修改
    #race-select .el-form-item__content .el-select{
      margin-left: 0 !important;
    }
    // 患者列表页面 修改患者信息弹窗的选择民族下拉框样式修改
    #raceType-select .el-form-item__content .el-select{
      margin-left: 0 !important;
    }
    // 新建患者年龄输入框
    #input-box_1 .el-input__inner{
      padding: 0;
      text-align: center;
    }
  
    // 编辑患者信息弹框年龄部分的element样式修改
    #formitem-gender-age .el-form-item__content{
      display: flex;
    }
    #formitem-gender-age .age-box .el-input__inner{
      padding: 0;
      text-align: center;
    }
  
    // 历史列表样式修改
    .history-tabel .cell{
      padding: 0 2px;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .history-tabel .el-table tr{
      background-color: inherit;
    }
    .history-tabel .el-table th{
      color: #61a2bf;
      background-color: inherit;
      font-weight: bold;
    }
    .history-tabel .el-table--striped .el-table__body tr.el-table__row--striped td{
      background-color: inherit;
    }
    // 影像诊断input框样式修改
    #diagnose-result-input{
      font-size: 16px;
    }
</style>
